import * as _ from '@antv/util';
export function parseFields(field) {
    if (_.isArray(field)) {
        return field;
    }
    return field.split('*');
}
//# sourceMappingURL=parse-fields.js.map